module.exports = __webpack_public_path__ + "img/dask-zorunlu-deprem-sigortasi.b0d09d1c.png";